import React, { useState, useEffect } from "react";

import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/Embedded Solutions.jpg'
import img2 from '../Assets/Mask group.png'
import img3 from '../Assets/Group 184.png'
import img4 from '../Assets/Group 11.png'
import heading from '../Assets/heading3.png'
import bg from '../Assets/embeded.png.webp'
import icon from '../Assets/Our-Experties-2.png'
import icon2 from '../Assets/Our-Experties-1.png'
import icon3 from '../Assets/Our-Experties.png'

function EmbeddedSolutions() {
        const [activeTab, setActiveTab] = useState(1);
          const handleTabChange = (tabIndex) => {
            setActiveTab(tabIndex);
          };
  return (
   <>
    <Navbar/>
     {/* <div className='AboutUs-banner'>
        <h3>Embedded Solutions</h3>
    
        </div> */}
            <div className="banner-heading">
          <img src={heading}/>
        </div>
        <div className='silicon'>
  <div className='silicon-left'>
<p>Driving Embedded Excellence</p>

<h3>Embedded Solutions</h3>
<br/>
<br/>
<h4>Semicave is your trusted partner for end-to-end support in embedded  solutions development. We specialize in guiding you through every phase of your project, starting from the initial idea all the way to the rigorous conformance testing stage.
<br/>Our team boasts extensive experience across a wide array of hardware platforms and processor architectures, as well as proficiency in real-time operating systems. This expertise allows us to offer tailored solutions that meet your specific requirements and ensure the seamless development of embedded systems.
<br/>Whether it’s hardware design, software development, or the critical integration of hardware and software components, semicave is here to provide the expertise and support you need. With our meticulous attention to detail and commitment to efficiency, we’ll help you bring your embedded projects to fruition successfully.

</h4>

        </div>
          <div className='silicon-right'>
<img src={img}/>
        </div>
        </div>
      
 <div className="silicon-box">

        <div className="dg-back">
        <p style={{color:"white"}}>Design to Development across the verticals</p>
        <h3 style={{color:"white"}}>Embedded Solutions Expertise</h3>
        <h5>Our portfolio includes system architecture as well as design, development, product validation and testing for Embedded Solutions across a variety of hardware platforms</h5>
<img src={bg}/>
</div>

     </div>
     <div className="our-expertise">
     <h3>Our Expertise</h3>
<br/>
<br/>
  <div className="our-expertise-boxs">
  <div className="our-expertise-box">
  <img src={icon}/>

  <h3>Platform Support</h3>
  <p>We provide platform support across various technologies, including Embedded Linux and Android. Additionally, we offer expertise in Mentor, Keil, ARM, Microchip, Atmel, Intel, and PPC platforms.</p>

     </div>
       <div className="our-expertise-box">
  <img src={icon2}/>

  <h3>Engineering</h3>
  <p>We offer comprehensive services covering the entire product development lifecycle, from conceptualization to testing. Our expertise includes engineering solutions such as device drivers, Board Support Packages (BSPs), communication protocol development, firmware development, and board bring-up. We specialize in Real-Time Operating System (RTOS) porting and customization, as well as Integrated Development Environment (IDE) development.
</p>

     </div>
       <div className="our-expertise-box">
  <img src={icon3}/>

  <h3>Testing</h3>
  <p>We specialize in comprehensive testing services covering various aspects of software development. Our expertise includes system integration testing, sanity testing, performance testing, interoperability testing, regression and stress testing, functional testing, and unit testing with code coverage analysis.</p>

     </div>
     </div>
     </div>

       <div className="our-expertise">
     <h3>Embedded Software</h3>
<br/>
<br/>
<div className="Embedded-boxs">
<div className="Embedded-box">
<div className="Embedded-img Embedded-img2">
<div className="overlay3">

<h5>FW/Device Drivers/AI/ML</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">

<p><i class="bi bi-arrow-right-short"></i>C, C++</p>
<p><i class="bi bi-arrow-right-short"></i>OS Porting</p>
<p><i class="bi bi-arrow-right-short"></i>Win/Linux/Android/RTOS</p>
<p><i class="bi bi-arrow-right-short"></i>Kernal Sys Build & Validation</p>
<p><i class="bi bi-arrow-right-short"></i>BSP & Firmware development</p>
<p><i class="bi bi-arrow-right-short"></i>UEFI/BIOS</p>
<p><i class="bi bi-arrow-right-short"></i>AI & ML</p>
<p><i class="bi bi-arrow-right-short"></i>Storage</p>
<p><i class="bi bi-arrow-right-short"></i>Multimedia , Display, BT, Wi-Fi</p>
<p><i class="bi bi-arrow-right-short"></i>Automation & Validation</p>
<p><i class="bi bi-arrow-right-short"></i>Opensource Community Support</p>


</div>


</div>
<div className="Embedded-box">
<div className="Embedded-img Embedded-img3">
<div className="overlay3">

<h5>Mobile/Web Application</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">

<p><i class="bi bi-arrow-right-short"></i>Android
</p>
<p><i class="bi bi-arrow-right-short"></i>Java/J2EE
</p>
<p><i class="bi bi-arrow-right-short"></i>.Net
</p>
<p><i class="bi bi-arrow-right-short"></i>iPython
</p>
<p><i class="bi bi-arrow-right-short"></i>HTML
</p>
<p><i class="bi bi-arrow-right-short"></i>CSS
</p>
<p><i class="bi bi-arrow-right-short"></i>Rest
</p>
<p><i class="bi bi-arrow-right-short"></i>Angular, React, Vue JS
</p>
<p><i class="bi bi-arrow-right-short"></i>SQL
</p>
<p><i class="bi bi-arrow-right-short"></i>Mongo db
</p>
<p><i class="bi bi-arrow-right-short"></i>Build & Integration</p>


</div>


</div>
<div className="Embedded-box">
<div className="Embedded-img Embedded-img4">
<div className="overlay3">

<h5>
Diagnostic Software</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">

<p><i class="bi bi-arrow-right-short"></i>Performance Monitoring Tools</p>
<p><i class="bi bi-arrow-right-short"></i>IP Routing Protocols, MPLS</p>
<p><i class="bi bi-arrow-right-short"></i>Network Analyzer</p>
<p><i class="bi bi-arrow-right-short"></i>System Information Tools</p>
<p><i class="bi bi-arrow-right-short"></i>Storage Analyzer</p>
<p><i class="bi bi-arrow-right-short"></i>Data Plane</p>
<p><i class="bi bi-arrow-right-short"></i>Processor Diagnostic Tool</p>
<p><i class="bi bi-arrow-right-short"></i>Memory Analyzer Tools</p>



</div>


</div>
<div className="Embedded-box">
<div className="Embedded-img Embedded-img5">
<div className="overlay3">

<h5>Automation & Validation</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">

<p><i class="bi bi-arrow-right-short"></i>Framework development</p>
<p><i class="bi bi-arrow-right-short"></i>Test script development</p>
<p><i class="bi bi-arrow-right-short"></i>Python/Perl/C/C++</p>
<p><i class="bi bi-arrow-right-short"></i>Selenium</p>
<p><i class="bi bi-arrow-right-short"></i>Pre and Post silicon validation</p>
<p><i class="bi bi-arrow-right-short"></i>HW/SW integration</p>
<p><i class="bi bi-arrow-right-short"></i>Graphics Driver Validation</p>
<p><i class="bi bi-arrow-right-short"></i>BIOS Validation</p>
<p><i class="bi bi-arrow-right-short"></i>Power and Performance validation</p>
<p><i class="bi bi-arrow-right-short"></i>E2E validation on Server/Client/Mobile platforms</p>



</div>


</div>
</div>
     </div>

    <Footer/>

</>
  )
}

export default EmbeddedSolutions